/**
 * Created by PanJiaChen on 16/11/18.
 */

/*外链 */
/**
 * @param {string} path 
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL (url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail (email) {
  const reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.(?:com|cn)$/
  return reg.test(email)
}

/**
 * @param {string} phone
 * @returns {Boolean}
 */
export function validatePhone (phone) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}

/* 数字 */
/**
 * @param {string} number
 * @returns {Boolean}
 */
export function validNumber (val) {
  const reg = /^[^0-9.]+$/
  return reg.test(val)
}

/* 汉字 */
/**
 * @param {string} hanzi
 * @returns {Boolean}
 */
export function validHanZi (str) {
  const reg = /^[\u4e00-\u9fa5]+$/
  return reg.test(str)
}

/* 特殊字符 */
/**
 * @param {string} specialchar
 * @returns {Boolean}
 */
export function validSpecialChar (str) {
  const reg = /^[!@#$%^&*(),.?":{}|<>]+$/
  return reg.test(str)
}